import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbTestingService, AbTestingUserGroup } from './ab-testing.service';

export const STORY_NUMBER_FE_AB_TESTING = {
  PRIMARY_NBA: '4180', // primary NBA A/B tests (currently used for B2O aka direct sales aka buy journey)
  STAGE_ROTATION_INDICATORS: '34', // MBCC-34,
  AFFINITY_SCORE: '912', // MBCC-912
  UPSELLING_RECOMMENDATION_WHOLESALE: '1116', // MBCC-1116
  SUMMARY_ACCORDIONS: '1113', // MBCC-1113
  RECOMMENDATION_LABELS: '1204', //MBCC-1204, recommendation labels on off test,
  MODEL_SPECIFIC_BACKGROUNDS: '2010',
  SUMMARY_MOBILE_STAGE: '1922',
  BUILT_TO_ORDER_FORM: '2410', // AB test for different bto forms
  SUMMARY_EQUIPMENT_ACCORDIONS: '2271'
};

@Injectable({
  providedIn: 'root'
})
export class AbTestRunnerService {
  public constructor(private readonly abTestingService: AbTestingService) {}

  public shouldBeActiveFor(givenUserStory: string, givenUserGroup: AbTestingUserGroup = 'A'): Observable<boolean> {
    return this.abTestingService
      .getUserGroupByStoryNumber(givenUserStory)
      .pipe(map(userGroup => userGroup === givenUserGroup));
  }
}
